import { Inject } from '@odinjs/odin';

import { DialogServiceProvider, Endpoint, ToastService } from '@philips-emr/hpms-provider-commons';
import { FormAPI, ModalAPI, PanelAPI, ToastNotificationAPI } from '@philips-emr/tws-components';
import { ToastLevel } from '@philips-emr/tws-constants';
import Controller, { OnCancel, OnClose, OnSelectItem, OnSubmit } from '@philips-emr/tws-core/lib/client';
import { SelectItemEvent, SubmitEvent } from '@philips-emr/tws-core/lib/component/types';
import { HistoryService, HttpService, MessageService } from '@philips-emr/tws-core/lib/services';
import { RequestResponse } from '@philips-emr/tws-core/lib/services/http-service';

import { FragmentNames } from '../../codegen';
import { NewAccreditationUpdateAliases as Aliases } from '../../codegen/constants/aliases/new-accreditation-update-aliases';
import { Route } from '../../route';
import BaseController from '../BaseController';

import { TypeAccreditation } from './accreditation-update-controller';

interface DataTerm {
  nameTerm?: string,
  term: string
}

@Controller({ fragment: FragmentNames.NEW_ACCREDITATION_UPDATE })
class NewAccreditationUpdateController extends BaseController {
  @Inject(Aliases.PANEL_TERM)
  private panelTerm: PanelAPI;
  @Inject(Aliases.MODAL_TERM)
  private modalTerm: ModalAPI;
  @Inject(Aliases.FORM_TERM)
  private formTerm: FormAPI;
  @Inject(Aliases.TOAST_NOTIFICATION)
  private toast: ToastNotificationAPI;

  @OnSelectItem(Aliases.DECK_ACCREDITATION_CATEGORIES)
  onSelectitemAccreditationCategories(event: SelectItemEvent<TypeAccreditation>): void {
    const { message, nrSequence } = event.item;
    if (message) {
      DialogServiceProvider.alert(message);
    } else {
      const nrSeqTypeAccreditation = nrSequence;
      const { nrSeqProvider } = this.context.getBulkData();
      HttpService.get<DataTerm>(Endpoint.GET.TYPE_TERM_ACCREDITATION, { nrSeqProvider, nrSeqTypeAccreditation  })
        .then((resp) => {
          const data = resp.body;
          if (data) {
            const { nameTerm = '', term } = data;
            this.panelTerm.setVisible(true);
            this.modalTerm.setTitle(nameTerm);
            this.formTerm.setData({ term, nrSeqTypeAccreditation, nrSeqProvider });
          } else {
            this.generateAccreditationUpdate(Number(nrSeqProvider), nrSeqTypeAccreditation);
          }
        }).catch(() => ToastService.open({ message: MessageService.translate('provider.error-process-request'), level: ToastLevel.ERROR }));
    }
  }

  private generateAccreditationUpdate(nrSeqProvider: number, nrSeqTypeAccreditation: number): void {
    HttpService.post(Endpoint.POST.GENERATE_ACCREDITATION_UPDATE, { nrSeqProvider, nrSeqTypeAccreditation })
      .then((resp) => {
        const { body } = resp as RequestResponse;
        if (body) {
          const { response } = body as unknown as { response: number};
          HistoryService.push(Route.ACCREDITATION_UPDATE_SIDEBAR_MENU, { nrSeqAccreditation: response, nrSeqTypeAccreditation });
        }
      }).catch((response) => ToastService.open(response));
  }

  @OnSubmit(Aliases.FORM_TERM)
  onSubmitFormTerm(event: SubmitEvent): void {
    const { record } = event;
    if (!record || !record.ieTerms) {
      this.toast.setVisible(true);
      this.scrollDownPanelTerm();
      return;
    }
    const body = event.record;
    this.panelTerm.setVisible(false);
    const { nrSeqProvider, nrSeqTypeAccreditation } = body;
    this.generateAccreditationUpdate(Number(nrSeqProvider), nrSeqTypeAccreditation);
  }

  scrollDownPanelTerm(): void {
    const termPanel = document.querySelector<HTMLDivElement>('.c-modal__content--with-stack-manager');
    if (termPanel) {
      const { scrollHeight } = termPanel;
      termPanel.scrollTo({ top: scrollHeight, behavior: 'smooth' });
    }
  }

  @OnClose(Aliases.MODAL_TERM)
  closeModal(): void {
    this.panelTerm.setVisible(false);
  }

  @OnCancel(Aliases.FORM_TERM)
  onCancelFormTerm(): void {
    this.panelTerm.setVisible(false);
  }
}

export {
  NewAccreditationUpdateController,
};
